import { motion } from "framer-motion";
import React, { ReactNode, useState } from "react";

import styles from "@components/ProgressCircle.module.css";

type Props = {
  children?: ReactNode;
  duration?: number;
  percents: number;
  size: number;
  type?: "hover" | "set";
};

const ProgressCircle = ({ children, duration = 0.3, percents, size, type = "set" }: Props) => {
  const radius = 45;
  const circumference = Math.ceil(2 * Math.PI * radius);
  const fillPercents = Math.abs(Math.ceil((circumference / 100) * (percents - 100)));
  const [isHovered, setHovered] = useState(false);

  const transition = {
    duration,
    ease: "easeIn"
  };

  const variants = {
    hidden: {
      strokeDashoffset: circumference,
      transition
    },
    show: {
      strokeDashoffset: fillPercents,
      transition
    }
  };

  return (
    <div
      className={styles.relativeContainer}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children && <div className={styles.centerContent}>{children}</div>}

      <svg
        height={size}
        style={{
          overflow: "visible"
        }}
        version="1.1"
        viewBox="0 0 100 100"
        width={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle className={styles.emptyCircle} cx="50" cy="50" r={radius} />
      </svg>
      <svg
        height={size}
        style={{
          marginLeft: -size,
          overflow: "visible",
          position: "absolute",
          transform: "rotate(-90deg)"
        }}
        viewBox="0 0 100 100"
        width={size}
      >
        <motion.circle
          animate={type === "set" ? "show" : isHovered ? "show" : "hidden"}
          className={`${styles.filledCircle} ${type === "set" ? styles.setColor : ""}`}
          cx="50"
          cy="50"
          fill="transparent"
          initial="hidden"
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={fillPercents}
          strokeWidth={15}
          variants={variants}
        />
      </svg>
    </div>
  );
};

export default ProgressCircle;
